import { Component } from '@angular/core';
import { AuthorizationAwareComponent } from '../../../core/authorization-aware-component';
import { AppState } from '../../../app-state';
import { Store as NgrxStore } from '@ngrx/store';
import { DetailState, selectDetailState } from '../../detail-state';
import { AnalystRatingResponse } from '../../../core/store/rating/analyst-rating-response';
import { StoreServices } from '../../../core/store/store-services';
import { RequestMoreStoreInsightWizard } from '../store-alerts-panel/request-more-insight-wizard/request-more-store-insight-wizard';
import { Store } from '../../../core/models';
import { WizardRunnerService } from '../../../core/wizard/wizard-runner.service';
import { HitTrackingService } from 'src/app/core/hit-tracking/hit-tracking.service';
import { USER_TRACKING_ACTION_DESCRIPTIONS, USER_TRACKING_ACTIONS, USER_TRACKING_SOURCES } from 'src/app/core/constants/user-tracking.constants';
import { AdditionalInsightsDataService } from '../../../core/services/additional-insights-data.service';

@Component({
  standalone: false,
  selector: 'mtn-store-additional-insights-panel',
  templateUrl: './store-additional-insights-panel.component.html',
  styleUrls: ['./store-additional-insights-panel.component.scss']
})
export class StoreAdditionalInsightsPanelComponent extends AuthorizationAwareComponent {

  cardDescriptionRatings = 'Not yet evaluated';
  cardDescriptionServices = 'Not yet evaluated';
  cardTitleRatings = 'No Analyst Ratings Available';
  cardTitleServices = 'Unknown Services';
  marketName: any;
  ratings: AnalystRatingResponse;
  services: StoreServices;
  store: Store;

  constructor(protected ngrxStore: NgrxStore<AppState>,
    private hitTrackingService: HitTrackingService,
    private wizardRunner: WizardRunnerService,
    private additionalInsightsDataService: AdditionalInsightsDataService) {
    super(ngrxStore);
  }

  onAuthorizationChange(): void { }

  onAuthorizationInit(): void {
    this.subscribeToDetailState();
  }

  openRequestMoreInsightWizard(): void {
    const wizard = new RequestMoreStoreInsightWizard();
    wizard.model = {
      store: this.store,
      userProfile: this.currentUser
    };

    this.wizardRunner.run(wizard);
  }

  private subscribeToDetailState(): void {
    this.addSubscription(
      selectDetailState(this.ngrxStore)
        .subscribe((state: DetailState) => {
          this.ratings = state.analystRating;
          const feature = state.marketArea?.getFeature();
          this.marketName = feature?.properties ? feature.properties['name'] : null;
          this.services = state.services;
          this.store = state.store;
          
          // Update service with data
          this.additionalInsightsDataService.updateServices(this.services);
          this.additionalInsightsDataService.updateRatings(this.ratings);
        })
    );
  }

  trackUserClick(eventName: string, eventType?: any): void {
    const location = this.store?.space?.location;
    const shoppingCenter = this.store?.space?.shoppingCenter;
    const enrichedMetadata = {
      storeId: this.store?.uuid,
      storeName: this.store?.name,
      addressLine1: location?.addressLine1,
      city: location?.city,
      state: location?.state,
      postalCode: location?.postalCode,
      county: location?.county,
      cbsa: this.marketName,
      shoppingCenterName: shoppingCenter?.name,
      landlord: shoppingCenter?.ownerCompany?.name
    };

    const data = enrichedMetadata;
    console.log(eventType);
    this.hitTrackingService.hitTheUserTracking(
      USER_TRACKING_SOURCES.STORE_ADDITIONAL_INSIGHTS_PANEL,
      data,
      USER_TRACKING_ACTIONS.CLICK_EVENT,
      USER_TRACKING_ACTION_DESCRIPTIONS[USER_TRACKING_ACTIONS.CLICK_EVENT](eventName)
    ).subscribe();
  }
}
